/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { Message, Icon } from '@mairistem/composants';
import { useHistory } from 'react-router-dom';

import { baseUrlApp } from '@/routes';

interface HubeeStatusMessageProps {
  serialized: boolean;
  liaisonActive: boolean;
  showPromotionOnly?: boolean;
}

/**
 * Composant pour afficher les messages selon le status Hubee
 * - liaison active : accès aux fonctionnalités
 * - liaison inactive sans serial : message proposant de s'abonner
 * - liaison inactive avec serial : message indiquant d'activer dans les paramètres
 * - pas de serial : message de promotion
 */
const HubeeStatusMessage = ({
  serialized,
  liaisonActive,
  showPromotionOnly = false,
}: HubeeStatusMessageProps) => {
  const history = useHistory();

  // Pas de serial : message de promotion
  if (!serialized) {
    return (
      <Message info icon style={{ margin: '1em' }}>
        <Icon name="info circle" />
        <Message.Content>
          <Message.Header>Téléservice Hubee disponible</Message.Header>
          <p>
            Le téléservice Hubee permet aux citoyens de faire leurs demandes de
            recensement en ligne.
            {!showPromotionOnly && (
              <>
                {' '}
                <br />
                <strong>Abonnez-vous pour bénéficier de ce service !</strong>
              </>
            )}{' '}
            <a
              href="https://www.jvs-mairistem.fr/actualites/hubee-laccelerateur-de-digitalisation-de-ladministration-au-service-de-tous_1533/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#4183c4' }}
            >
              En savoir plus
            </a>
          </p>
        </Message.Content>
      </Message>
    );
  }

  // Avec serial mais liaison inactive : message pour activer dans les paramètres
  if (serialized && !liaisonActive) {
    return (
      <Message warning icon style={{ margin: '1em' }}>
        <Icon name="warning sign" />
        <Message.Content>
          <Message.Header>Liaison Hubee désactivée</Message.Header>
          <p>
            Le téléservice Hubee est disponible mais la liaison n&apos;est pas
            active.{' '}
            <button
              type="button"
              onClick={() => {
                history.push(`${baseUrlApp}parametres/generaux`);
              }}
              style={{
                background: 'none',
                border: 'none',
                color: '#4183c4',
                textDecoration: 'underline',
                cursor: 'pointer',
                padding: 0,
              }}
            >
              Activez-la dans les paramètres généraux
            </button>{' '}
            pour permettre la réception des demandes dématérialisées.
          </p>
        </Message.Content>
      </Message>
    );
  }

  // Liaison active : pas de message, accès normal aux fonctionnalités
  return null;
};

export default HubeeStatusMessage;
